// Header Search

document.addEventListener('DOMContentLoaded', function() {
    var searchForm = document.querySelector('[data-search-form]');
    var searchInput = document.querySelector('[data-search-input]');
    var clearBtn = document.querySelector('[data-search-clear]');
    var closeBtn = document.querySelector('[data-search-flyout-close]');
    var resultsContainer = document.querySelector('.search-form__results-container');
    var wrapperContent = document.querySelector('.search-flyout__wrapper-content');

    if (!searchForm || !searchInput) return;

    function updateVisibility() {
        var hasText = searchInput.value.trim() !== '';
        var isOpen = resultsContainer && resultsContainer.getAttribute('data-animation-state') === 'open';

        if (hasText && isOpen) {
            wrapperContent.style.display = 'none';
            resultsContainer.style.display = '';
        } else if (!hasText) {
            resultsContainer.style.display = 'none';
            wrapperContent.style.display = 'flex';
        }
    }

    searchInput.addEventListener('input', function() {
        if (searchInput.value.trim() !== '') {
            searchForm.classList.add('typing');
        } else {
            searchForm.classList.remove('typing');
        }
        updateVisibility();
    });

    if (clearBtn) {
        clearBtn.addEventListener('click', function() {
            searchInput.value = '';
            searchInput.focus();
            searchForm.classList.remove('typing');
            updateVisibility();
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            searchInput.value = '';
            searchForm.classList.remove('typing');
            updateVisibility();
        });
    }

    if (resultsContainer) {
        var observer = new MutationObserver(function() {
            updateVisibility();
        });

        observer.observe(resultsContainer, {
            attributes: true,
            attributeFilter: ['data-animation-state'],
        });
    }

    // Dynamic Popular Search
    var STORAGE_KEY = 'joolora_popular_searches';
    var MAX_ITEMS = 3;
    var popularInfo = document.querySelector('[data-popular-search-info]');

    function getStoredSearches() {
        try {
            var stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            return [];
        }
    }

    function saveSearchQuery(query) {
        if (!query || typeof query !== 'string') return;
        var cleaned = query.trim();
        if (!cleaned || cleaned.length < 2) return;

        var searches = getStoredSearches();
        searches = searches.filter(function(item) {
            return item.toLowerCase() !== cleaned.toLowerCase();
        });
        searches.unshift(cleaned);
        if (searches.length > MAX_ITEMS) {
            searches = searches.slice(0, MAX_ITEMS);
        }

        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(searches));
        } catch (e) {}
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    if (popularInfo) {
        var defaultItems = [];
        popularInfo.querySelectorAll('li').forEach(function(li) {
            var txt = li.textContent.trim();
            if (txt) defaultItems.push(txt);
        });

        function renderPopularSearches() {
            var userSearches = getStoredSearches();
            var displayItems = userSearches.length > 0 ? userSearches : defaultItems;

            if (displayItems.length === 0) return;

            var html = '<ul>';
            displayItems.forEach(function(term) {
                var searchUrl = '/search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last';
                html += '<li><a href="' + searchUrl + '" class="popular_search_link" data-search-term="' + escapeHtml(term) + '">' + escapeHtml(term) + '</a></li>';
            });
            html += '</ul>';

            popularInfo.innerHTML = html;
        }

        renderPopularSearches();

        popularInfo.addEventListener('click', function(e) {
            var link = e.target.closest('[data-search-term]');
            if (!link) return;

            var term = link.getAttribute('data-search-term');
            if (!term) return;

            saveSearchQuery(term);

            if (searchInput && searchForm) {
                searchInput.value = term;
                searchForm.submit();
            }
        });
    }

    searchForm.addEventListener('submit', function() {
        if (searchInput && searchInput.value) {
            saveSearchQuery(searchInput.value);
            if (popularInfo) renderPopularSearches();
        }
    });

    document.addEventListener('click', function(e) {
        var predResult = e.target.closest('.predictive-search-results-list__item-result, [data-predictive-search-button]');
        if (predResult && searchInput && searchInput.value) {
            saveSearchQuery(searchInput.value);
            if (popularInfo) renderPopularSearches();
        }
    });
});

// 1. SHARED UTILITIES

function formatMoney(cents) {
    return Shopify.formatMoney(cents, theme.moneyFormat);
}

function updatePrice(priceContainer, variant) {
    if (!priceContainer || !variant) return;

    var priceEl = priceContainer.querySelector('[data-product-price]');
    var compareEl = priceContainer.querySelector('[data-product-price-compare]');
    var saleBadgeEl = priceContainer.querySelector('.product-price__sale-badge');
    var unitPriceWrapper = priceContainer.querySelector('[data-unit-price]');
    var unitPriceAmount = priceContainer.querySelector('[data-unit-price-amount]');
    var unitPriceMeasure = priceContainer.querySelector('[data-unit-price-measure]');
    var totalQuantity = priceContainer.querySelector('[data-total-quantity]');
    var taxLine = priceContainer.querySelector('[data-tax-line]');

    var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (priceEl) {
        priceEl.textContent = formatMoney(variant.price);
        priceEl.classList.toggle('product-price__minimum--sale', isOnSale);
    }

    if (compareEl) {
        if (isOnSale) {
            compareEl.textContent = formatMoney(variant.compare_at_price);
            compareEl.classList.remove('product-price__compare--hidden');
        } else {
            compareEl.textContent = '';
            compareEl.classList.add('product-price__compare--hidden');
        }
    }

    if (saleBadgeEl) {
        saleBadgeEl.style.display = isOnSale ? '' : 'none';
    }

    if (unitPriceWrapper) {
        if (variant.unit_price_measurement) {
            unitPriceWrapper.classList.remove('product-details__unit-price--hidden');
            if (unitPriceAmount) unitPriceAmount.textContent = formatMoney(variant.unit_price);
            if (unitPriceMeasure) {
                var ref = variant.unit_price_measurement.reference_value !== 1 ?
                    variant.unit_price_measurement.reference_value :
                    '';
                unitPriceMeasure.textContent = ref + variant.unit_price_measurement.reference_unit;
            }
            if (totalQuantity) {
                totalQuantity.textContent =
                    variant.unit_price_measurement.quantity_value + variant.unit_price_measurement.quantity_unit;
            }
        } else {
            unitPriceWrapper.classList.add('product-details__unit-price--hidden');
        }
    }

    if (taxLine) {
        taxLine.classList.toggle('product-details__tax-label--hidden', !variant.taxable);
    }
}

function updateVariantId(input, variant) {
    if (!input || !variant) return;
    input.value = variant.id;

    var masterSelect = document.querySelector('[data-variants]');
    if (masterSelect) {
        masterSelect.value = variant.id;
    }

    input.dispatchEvent(new Event('change', {
        bubbles: true
    }));

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url.toString());
}

function findMatchingVariant(variantsData, selectedOptions) {
    return variantsData.find(function(variant) {
        return selectedOptions.every(function(value, index) {
            return variant.options[index] === value;
        });
    });
}

// 2. PRODUCT DROPDOWN VARIANT (GLOBAL DELEGATION)

document.addEventListener('change', function(e) {
    var select = e.target.closest('[data-product-option]');
    if (!select) return;

    var container = select.closest('.product-details') || select.closest('.product__wrapper');
    if (!container) return;

    var optionIndex = select.dataset.productOption;
    var value = select.value;
    var label = container.querySelector('[data-selected-label="' + optionIndex + '"]');
    if (label) label.textContent = value;
});

// 3. PRODUCT PILLS & COLOR SWATCHES & VARIANT SELECTION (GLOBAL DELEGATION)

document.addEventListener('click', function(e) {
    var pill = e.target.closest('.product-details__pill');
    var swatch = e.target.closest('.color-swatches__btn');

    if (pill) {
        var container = pill.closest('.product-details') || pill.closest('.product__wrapper');
        if (!container) return;

        var optionIndex = parseInt(pill.dataset.pillOption);
        var value = pill.dataset.pillValue;

        container.querySelectorAll('[data-pill-option="' + optionIndex + '"]').forEach(function(p) {
            p.classList.remove('product-details__pill--selected');
            p.setAttribute('aria-pressed', 'false');
        });

        pill.classList.add('product-details__pill--selected');
        pill.setAttribute('aria-pressed', 'true');

        var group = container.querySelector('[data-pill-group="' + optionIndex + '"]');
        if (group) {
            var wrapper = group.closest('.product-details__option-wrapper');
            var selectedValEl = wrapper ? wrapper.querySelector('.product-details__option-selected-value') : null;
            if (selectedValEl) selectedValEl.textContent = value;
        }

        var hiddenSelect = container.querySelector('select[data-product-option="' + optionIndex + '"]');
        if (hiddenSelect) {
            hiddenSelect.value = value;
            hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        updateContainerVariantAndPrice(container);
    } else if (swatch) {
        var container = swatch.closest('.product-details') || swatch.closest('.product__wrapper');
        if (!container) return;

        var optionIndex = parseInt(swatch.dataset.swatchOption);
        var value = swatch.dataset.swatchValue;

        container.querySelectorAll('[data-swatch-option="' + optionIndex + '"]').forEach(function(s) {
            s.classList.remove('color-swatches__btn--selected');
            s.setAttribute('aria-pressed', 'false');
        });

        swatch.classList.add('color-swatches__btn--selected');
        swatch.setAttribute('aria-pressed', 'true');

        var labelEl = container.querySelector('[data-swatch-selected-label="' + optionIndex + '"]');
        if (labelEl) labelEl.textContent = value;

        var hiddenSelect = container.querySelector('select[data-product-option="' + optionIndex + '"]');
        if (hiddenSelect) {
            hiddenSelect.value = value;
            hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        updateContainerVariantAndPrice(container);
    }
});

function updateContainerVariantAndPrice(container) {
    var variantsJsonEl = container.querySelector('[data-variants-json]');
    if (!variantsJsonEl) return;
    var variantsData = JSON.parse(variantsJsonEl.textContent);

    var selectedOptions = [];
    container.querySelectorAll('.product-details__pill--selected').forEach(function(p) {
        selectedOptions[parseInt(p.dataset.pillOption)] = p.dataset.pillValue;
    });

    container.querySelectorAll('.color-swatches__btn--selected').forEach(function(s) {
        selectedOptions[parseInt(s.dataset.swatchOption)] = s.dataset.swatchValue;
    });

    container.querySelectorAll('select[data-product-option]').forEach(function(sel) {
        selectedOptions[parseInt(sel.dataset.productOption)] = sel.value;
    });

    var matchedVariant = findMatchingVariant(variantsData, selectedOptions);
    if (!matchedVariant) return;

    var variantInput = container.querySelector('[data-variant-id]');
    if (variantInput) {
        variantInput.value = matchedVariant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var priceContainer = container.querySelector('.product-details__price-container');
    if (priceContainer) {
        updatePrice(priceContainer, matchedVariant);
    }

    if (!container.closest('.modal--quickshop')) {
        var masterSelect = container.querySelector('[data-variants]');
        if (masterSelect) masterSelect.value = matchedVariant.id;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', matchedVariant.id);
        history.replaceState({}, '', url.toString());
    }
}

// 4. PRODUCT QUANTITY BOX (GLOBAL DELEGATION)

document.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('.quantity-selector__btn--minus');
    var plusBtn = e.target.closest('.quantity-selector__btn--plus');
    if (!minusBtn && !plusBtn) return;

    var btn = minusBtn || plusBtn;
    var quantityWrapper = btn.closest('.quantity-selector');
    if (!quantityWrapper) return;

    var input = quantityWrapper.querySelector('.quantity-selector__input');
    if (!input) return;

    var current = parseInt(input.value) || 1;
    var min = parseInt(input.min) || 1;

    if (minusBtn) {
        if (current > min) {
            input.value = current - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    } else if (plusBtn) {
        input.value = current + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var minus = quantityWrapper.querySelector('.quantity-selector__btn--minus');
    if (minus) {
        var newVal = parseInt(input.value) || 1;
        if (newVal <= min) {
            minus.classList.add('disabled');
            minus.setAttribute('disabled', 'disabled');
        } else {
            minus.classList.remove('disabled');
            minus.removeAttribute('disabled');
        }
    }
});

// 5. PRODUCT ACCORDION (GLOBAL DELEGATION)

document.addEventListener('click', function(e) {
    var titleIcon = e.target.closest('.product-accordion-title-icon');
    if (!titleIcon) return;

    var wrapper = titleIcon.closest('.product-accordion-wrapper');
    if (!wrapper) return;

    var desc = wrapper.querySelector('.product_accordion_desc');
    if (!desc) return;

    var isActive = titleIcon.classList.contains('active');
    var container = wrapper.closest('.product-details') || wrapper.closest('.product__wrapper') || document;

    container.querySelectorAll('.product-accordion-title-icon.active').forEach(function(activeTitle) {
        var activeWrapper = activeTitle.closest('.product-accordion-wrapper');
        var activeDesc = activeWrapper ? activeWrapper.querySelector('.product_accordion_desc') : null;

        activeTitle.classList.remove('active');
        if (activeDesc) {
            activeDesc.classList.remove('active');
            activeDesc.style.paddingBottom = '0px';
            activeDesc.style.height = '0px';
        }
    });

    if (!isActive) {
        desc.style.paddingBottom = '20px';
        titleIcon.classList.add('active');
        desc.classList.add('active');
        desc.style.height = desc.scrollHeight + 'px';
    }
});

// Collection Desktop Filter

(function () {
  'use strict';

  function clamp(val, min, max) {
    return Math.min(Math.max(val, min), max);
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      var ctx  = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function initAccordions() {
    document.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var summary = group.querySelector('[data-filter-group-summary]');
      var body    = group.querySelector('[data-filter-group-content]');
      if (!summary || !body) return;

      body.style.height = group.classList.contains('faceted-filters__filter-group--open')
        ? 'auto'
        : '0px';

      function toggle(e) {
        if (!e.target.closest('[data-filter-group-summary]')) return;
        e.preventDefault();
        e.stopPropagation();

        var isOpen = group.classList.contains('faceted-filters__filter-group--open');

        if (isOpen) {
          body.style.height = body.scrollHeight + 'px';
          body.offsetHeight;
          body.style.height = '0px';
          group.classList.remove('faceted-filters__filter-group--open');
          summary.setAttribute('aria-expanded', 'false');
        } else {
          body.style.height = body.scrollHeight + 'px';
          body.addEventListener('transitionend', function onEnd() {
            body.removeEventListener('transitionend', onEnd);
            if (group.classList.contains('faceted-filters__filter-group--open')) {
              body.style.height = 'auto';
            }
          });
          group.classList.add('faceted-filters__filter-group--open');
          summary.setAttribute('aria-expanded', 'true');
        }
      }

      summary.addEventListener('click', toggle);
      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
      });
    });
  }

  function initAvailabilityToggle() {
    document.querySelectorAll('[data-availability-toggle]').forEach(function (cb) {
      if (cb.closest('#cff-drawer')) return;

      cb.addEventListener('change', function () {
        var url = this.checked ? this.dataset.urlToAdd : this.dataset.urlToRemove;
        if (url) window.location.href = url;
      });
    });
  }

  function initPriceSliders() {
    document.querySelectorAll('[data-cff-slider]').forEach(function (slider) {
      var thumbMinEl = slider.querySelector('[data-cff-thumb="min"]');
      var thumbMaxEl = slider.querySelector('[data-cff-thumb="max"]');
      var fillEl     = slider.querySelector('[data-cff-fill]');

      var form        = slider.closest('form');
      var inputMin    = form ? form.querySelector('[data-cff-input="min"]') : null;
      var inputMax    = form ? form.querySelector('[data-cff-input="max"]') : null;
      var displayMin  = form ? form.querySelector('[data-cff-display="min"]') : null;
      var displayMax  = form ? form.querySelector('[data-cff-display="max"]') : null;
      var currencyMin = displayMin ? displayMin.dataset.currency : '';
      var currencyMax = displayMax ? displayMax.dataset.currency : '';

      if (!thumbMinEl || !thumbMaxEl || !fillEl) return;

      var rangeMin  = parseFloat(slider.dataset.rangeMin) || 0;
      var rangeMax  = parseFloat(slider.dataset.rangeMax) || 100;
      var initMin   = parseFloat(slider.dataset.initMin);
      var initMax   = parseFloat(slider.dataset.initMax);

      if (isNaN(initMin)) initMin = rangeMin;
      if (isNaN(initMax)) initMax = rangeMax;

      var currentMin = initMin;
      var currentMax = initMax;

      function updateUI() {
        var pctMin = ((currentMin - rangeMin) / (rangeMax - rangeMin)) * 100;
        var pctMax = ((currentMax - rangeMin) / (rangeMax - rangeMin)) * 100;

        thumbMinEl.style.left = pctMin + '%';
        thumbMaxEl.style.left = pctMax + '%';
        fillEl.style.left     = pctMin + '%';
        fillEl.style.width    = (pctMax - pctMin) + '%';

        thumbMinEl.setAttribute('aria-valuenow', Math.round(currentMin));
        thumbMaxEl.setAttribute('aria-valuenow', Math.round(currentMax));
      }

      var isInsideDrawer = !!slider.closest('#cff-drawer');

      var fireChange = debounce(function () {
        var minVal = currentMin <= rangeMin ? '' : Math.round(currentMin);
        var maxVal = currentMax >= rangeMax ? '' : Math.round(currentMax);

        if (inputMin) {
          inputMin.value = minVal;
          if (isInsideDrawer) {
            inputMin.dispatchEvent(new Event('input', { bubbles: true }));
          } else {
            inputMin.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        if (inputMax) {
          inputMax.value = maxVal;
          if (isInsideDrawer) {
            inputMax.dispatchEvent(new Event('input', { bubbles: true }));
          } else {
            inputMax.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        if (displayMin) {
          displayMin.value = minVal !== '' ? currencyMin + parseFloat(minVal).toFixed(2) : '';
        }
        if (displayMax) {
          displayMax.value = maxVal !== '' ? currencyMax + parseFloat(maxVal).toFixed(2) : '';
        }
      }, 350);

      function makeDraggable(thumbEl, isMin) {
        var dragging = false;

        function onStart(e) {
          e.preventDefault();
          dragging = true;
          document.addEventListener('mousemove', onMove);
          document.addEventListener('touchmove', onMove, { passive: false });
          document.addEventListener('mouseup',  onEnd);
          document.addEventListener('touchend', onEnd);
        }

        function onMove(e) {
          if (!dragging) return;
          e.preventDefault();

          var clientX = e.touches ? e.touches[0].clientX : e.clientX;
          var rect    = slider.getBoundingClientRect();
          var ratio   = clamp((clientX - rect.left) / rect.width, 0, 1);
          var raw     = rangeMin + ratio * (rangeMax - rangeMin);

          if (isMin) {
            currentMin = clamp(raw, rangeMin, currentMax - 1);
          } else {
            currentMax = clamp(raw, currentMin + 1, rangeMax);
          }

          updateUI();
          fireChange();
        }

        function onEnd() {
          dragging = false;
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('touchmove', onMove);
          document.removeEventListener('mouseup',  onEnd);
          document.removeEventListener('touchend', onEnd);
        }

        thumbEl.addEventListener('mousedown',  onStart);
        thumbEl.addEventListener('touchstart', onStart, { passive: false });

        thumbEl.addEventListener('keydown', function (e) {
          var step = (rangeMax - rangeMin) / 100;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
            if (isMin) currentMin = clamp(currentMin + step, rangeMin, currentMax - 1);
            else       currentMax = clamp(currentMax + step, currentMin + 1, rangeMax);
            updateUI(); fireChange();
          }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
            if (isMin) currentMin = clamp(currentMin - step, rangeMin, currentMax - 1);
            else       currentMax = clamp(currentMax - step, currentMin + 1, rangeMax);
            updateUI(); fireChange();
          }
        });
      }

      makeDraggable(thumbMinEl, true);
      makeDraggable(thumbMaxEl, false);

      if (displayMin) {
        displayMin.addEventListener('change', function () {
          var raw = this.value.replace(/[^\d.]/g, '');
          var val = parseFloat(raw) || rangeMin;
          currentMin = clamp(val, rangeMin, currentMax - 1);
          this.value = currencyMin + currentMin.toFixed(2);
          if (inputMin) {
            inputMin.value = currentMin <= rangeMin ? '' : Math.round(currentMin);
            if (isInsideDrawer) {
              inputMin.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
              inputMin.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          updateUI();
        });
      }
      if (displayMax) {
        displayMax.addEventListener('change', function () {
          var raw = this.value.replace(/[^\d.]/g, '');
          var val = parseFloat(raw) || rangeMax;
          currentMax = clamp(val, currentMin + 1, rangeMax);
          this.value = currencyMax + currentMax.toFixed(2);
          if (inputMax) {
            inputMax.value = currentMax >= rangeMax ? '' : Math.round(currentMax);
            if (isInsideDrawer) {
              inputMax.dispatchEvent(new Event('input', { bubbles: true }));
            } else {
              inputMax.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          updateUI();
        });
      }
      updateUI();
    });
  }

  function init() {
    initAccordions();
    initAvailabilityToggle();
    initPriceSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// Collection Filter Drawer

(function () {
  'use strict';

  var pendingParams = new URLSearchParams(window.location.search);

  var wrap      = document.getElementById('cff-drawer-wrap');
  var drawer    = document.getElementById('cff-drawer');
  var backdrop  = document.getElementById('cff-drawer-backdrop');
  var closeBtn  = document.getElementById('cff-drawer-close');
  var applyBtn  = document.getElementById('cff-apply-btn');
  var clearBtn  = document.getElementById('cff-clear-btn');
  var trigger   = document.querySelector('.faceted-filters__title');

  if (!wrap || !trigger) return;

  function openDrawer() {
    pendingParams = new URLSearchParams(window.location.search);
    syncDrawerInputs();

    wrap.classList.add('is-open');
    wrap.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('filter_drawer_open');

    closeBtn && closeBtn.focus();
  }

  function closeDrawer() {
    wrap.classList.remove('is-open');
    wrap.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('filter_drawer_open');

    trigger && trigger.focus();
  }

  function syncDrawerInputs() {
    var checkboxes = drawer.querySelectorAll('[data-filter-input][type="checkbox"]');
    checkboxes.forEach(function (cb) {
      var name  = cb.dataset.name;
      var value = cb.dataset.value;
      if (name && value) {
        cb.checked = pendingParams.getAll(name).indexOf(value) !== -1;
      }
    });

    var links = drawer.querySelectorAll('a[data-filter-input]');
    links.forEach(function (link) {
      var name  = link.dataset.name;
      var value = link.dataset.value;
      if (!name || !value) return;

      var isActive = pendingParams.getAll(name).indexOf(value) !== -1;
      var listItem = link.closest('.faceted-filters__filter-list-item');
      var pill     = link.querySelector('[data-checked], .faceted-filters__pill');

      if (isActive) {
        link.setAttribute('data-filter-active', '');
        listItem && listItem.classList.add('faceted-filters__filter-list-item--active');
        pill     && pill.setAttribute('data-checked', '');
      } else {
        link.removeAttribute('data-filter-active');
        listItem && listItem.classList.remove('faceted-filters__filter-list-item--active');
        pill     && pill.removeAttribute('data-checked');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var trg = e.target.closest('.faceted-filters__title');
    if (trg) {
      if (window.innerWidth > 959) return;
      e.preventDefault();
      openDrawer();
    }
  });

  closeBtn  && closeBtn.addEventListener('click', closeDrawer);
  backdrop  && backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrap.classList.contains('is-open')) closeDrawer();
  });

  drawer.addEventListener('click', function (e) {
    var link = e.target.closest('[data-filter-input]');
    if (!link) return;
    if (link.tagName === 'INPUT') return;

    e.preventDefault();

    var name  = link.dataset.name;
    var value = link.dataset.value;

    var currentVals = pendingParams.getAll(name);
    var idx         = currentVals.indexOf(value);
    var isActive    = idx !== -1;

    var listItem = link.closest('.faceted-filters__filter-list-item');
    var pill     = link.querySelector('.faceted-filters__pill, [data-checked]');

    if (isActive) {
      currentVals.splice(idx, 1);
      pendingParams.delete(name);
      currentVals.forEach(function (v) { pendingParams.append(name, v); });

      link.removeAttribute('data-filter-active');
      listItem && listItem.classList.remove('faceted-filters__filter-list-item--active');
      pill     && pill.removeAttribute('data-checked');
    } else {
      pendingParams.append(name, value);

      link.setAttribute('data-filter-active', '');
      listItem && listItem.classList.add('faceted-filters__filter-list-item--active');
      pill     && pill.setAttribute('data-checked', '');
    }
  });

  drawer.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb.matches('[data-filter-input][type="checkbox"]')) return;

    var name  = cb.dataset.name;
    var value = cb.dataset.value;

    if (cb.checked) {
      if (!pendingParams.getAll(name).includes(value)) {
        pendingParams.append(name, value);
      }
    } else {
      var kept = pendingParams.getAll(name).filter(function (v) { return v !== value; });
      pendingParams.delete(name);
      kept.forEach(function (v) { pendingParams.append(name, v); });
    }
  });

  function handleRangeEvent(e) {
    var input = e.target;
    if (!input.matches('[data-filter-range]')) return;

    var name = input.name;
    var val  = input.value;

    if (val) {
      pendingParams.set(name, val);
    } else {
      pendingParams.delete(name);
    }
  }

  drawer.addEventListener('input',  handleRangeEvent);
  drawer.addEventListener('change', handleRangeEvent);

  function countActiveFromPending() {
    var seen  = {};
    var count = 0;

    pendingParams.forEach(function (v, k) {
      if (k.startsWith('filter.')) {
        if (!seen[k]) seen[k] = [];
        seen[k].push(v);
      }
    });

    Object.keys(seen).forEach(function (k) { count += seen[k].length; });
    return count;
  }

  applyBtn && applyBtn.addEventListener('click', function () {
    var base = window.location.pathname;
    var qs   = pendingParams.toString();
    window.location.href = base + (qs ? '?' + qs : '');
  });

  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;

    var focusable = drawer.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );

    var first = focusable[0];
    var last  = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  });
})();

class QuantityWrap extends HTMLElement{
  constructor(){
    super();
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', (e)=>{this.quantityUpdate(e)}));
  }
  quantityUpdate(event){
    event.preventDefault();
    const button = event.target.closest('button');
    const quantityWrap = event.target.closest('.quantity__wrap');
    const input = quantityWrap.querySelector('input');
    if(button.name === 'plus'){
      input.stepUp();
    } else {
      input.stepDown();
    }
    const updatePage = ()=>{input.dispatchEvent(new KeyboardEvent('input', { bubbles: true }))};
    clearTimeout(updatePage);
    setTimeout(updatePage,300);
  }
}
customElements.define('quantity-wrap',QuantityWrap);

// Product Gallery Hover Zoom
document.addEventListener('mouseover', function(e) {
  var target = e.target.closest('[data-zoom-effect="on-hover"]');
  if (target && !target.classList.contains('product-image-zoomed')) {
      target.dispatchEvent(new MouseEvent('click', { bubbles: true, clientX: e.clientX, clientY: e.clientY }));
  }
});

// Size Guide Drawer
document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-size-guide-open]');
    if (openBtn) {
      e.preventDefault();
      var drawer = document.querySelector('[data-size-guide-drawer]');
      var backdrops = document.querySelectorAll('.size-guide-backdrop');
      if (drawer) {
        drawer.classList.add('size-guide-drawer--open');
        backdrops.forEach(b => b.classList.add('size-guide-backdrop--open'));
        document.body.classList.add('size_guide_open');
        document.body.style.overflow = 'hidden';
      }
    }

    var closeBtn = e.target.closest('[data-size-guide-close]');
    if (closeBtn) {
      e.preventDefault();
      var drawer = document.querySelector('[data-size-guide-drawer]');
      var backdrops = document.querySelectorAll('.size-guide-backdrop');
      if (drawer) {
        drawer.classList.remove('size-guide-drawer--open');
        backdrops.forEach(b => b.classList.remove('size-guide-backdrop--open'));
        document.body.classList.remove('size_guide_open');
        document.body.style.overflow = '';
      }
    }
  });
});

// Product Gallery Touch Swipe Slider (Mobile)
(function() {
  var viewport = document.querySelector('[data-product-gallery-viewport]');
  if (!viewport) return;

  var startX = 0;
  var startY = 0;

  viewport.addEventListener('touchstart', function(e) {
    if (!e.touches || e.touches.length === 0) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });

  viewport.addEventListener('touchend', function(e) {
    if (!e.changedTouches || e.changedTouches.length === 0) return;
    var endX = e.changedTouches[0].clientX;
    var endY = e.changedTouches[0].clientY;

    var deltaX = endX - startX;
    var deltaY = endY - startY;

    if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
      var thumbnails = Array.from(document.querySelectorAll('[data-product-gallery-thumbnail]'));
      if (!thumbnails.length) return;

      var selectedIndex = thumbnails.findIndex(function(t) {
        return t.getAttribute('data-product-gallery-selected') === 'true';
      });

      if (selectedIndex === -1) selectedIndex = 0;

      if (deltaX < 0) {
        // Swipe Left -> Next Image
        var nextIndex = (selectedIndex + 1) % thumbnails.length;
        thumbnails[nextIndex].click();
      } else {
        // Swipe Right -> Previous Image
        var prevIndex = (selectedIndex - 1 + thumbnails.length) % thumbnails.length;
        thumbnails[prevIndex].click();
      }
    }
  }, { passive: true });
})();